import { useLocation, Navigate, Outlet } from "react-router-dom";
import useAuth from "../hooks/useAuth";
import { useEffect, useState } from "react";

const RequireAuth = ({ allowedRoles, ability, abilities, redirectPath = "/Management?tab=profile" }) => {
    const { auth, setAuth } = useAuth();
    const location = useLocation();
    const [layout, setLayout] = useState(null);

    useEffect(() => {
        if (auth?.accessToken && auth?.permissions?.length) {
            handleAuth();
        }
    }, [auth]);
    const handleAuth = async () => {
        if (
            (!allowedRoles || (allowedRoles && allowedRoles?.length && auth?.roles?.find(role => allowedRoles?.includes(role.name)))) &&
            (!ability || (ability && ability?.length && auth?.permissions?.some(permission => ability?.includes(permission)))) &&
            (!abilities || (abilities && abilities?.length && abilities?.every(ability => auth?.permissions?.includes(ability))))
        ) {
            setLayout(<Outlet />);
        } else if (auth?.accessToken && auth?.permissions?.length) {
            window.location.href = redirectPath;
        } else {
            setLayout(<Navigate to="/login" state={{ from: location }} replace />);
        }
    }
    return (
        layout ?? <></>
    );
}

export default RequireAuth;